'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _helpButton = require('../../../static/icons/help-button.svg');var _helpButton2 = _interopRequireDefault(_helpButton);
var _exclamationButton = require('../../../static/icons/exclamation-button.png');var _exclamationButton2 = _interopRequireDefault(_exclamationButton);
var _BottomTooltip = require('./BottomTooltip.scss');var styles = _interopRequireWildcard(_BottomTooltip);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

BottomTooltip = function (_Component) {_inherits(BottomTooltip, _Component);function BottomTooltip() {var _temp, _this, _ret;_classCallCheck(this, BottomTooltip);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showTooltip: false }, _this.











    setWrapperRef = function (node) {
      _this.wrapperRef = node;
    }, _this.

    setVisibility = function (showTooltip) {_this.setState({ showTooltip: showTooltip });}, _this.

    handleClickOutside = function (event) {
      if (_this.props.closeOnClickOutside && _this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
        _this.setState({ showTooltip: false });
      }
    }, _this.

    clickHandler = function (evt) {
      evt.preventDefault();

      var showTooltip = !_this.state.showTooltip;
      _this.setState({ showTooltip: showTooltip });
      if (_this.props.onToggle) {
        _this.props.onToggle(evt, showTooltip);
      }
    }, _this.

    renderIcon = function () {return !!_this.props.icon ?
      _this.props.icon :
      _react2.default.createElement('img', { src: _this.props.warnTooltip ? _exclamationButton2.default : _helpButton2.default, alt: 'help-icon' });}, _temp), _possibleConstructorReturn(_this, _ret);}BottomTooltip.prototype.componentDidMount = function componentDidMount() {document.addEventListener('mousedown', this.handleClickOutside);};BottomTooltip.prototype.componentWillUnmount = function componentWillUnmount() {document.removeEventListener('mousedown', this.handleClickOutside);};BottomTooltip.prototype.

  render = function render() {var _this2 = this;
    var handleHoverEvent = this.props.showOnHover ?
    { onMouseEnter: function onMouseEnter() {return _this2.setVisibility(true);}, onMouseLeave: function onMouseLeave() {return _this2.setVisibility(false);} } :
    Object.create(null);

    return (
      _react2.default.createElement('div', _extends({
          className: (0, _classnames2.default)(styles.tooltipContainer, this.props.className, { open: this.state.showTooltip }),
          onClick: this.clickHandler,
          ref: this.setWrapperRef },
        handleHoverEvent),

        this.renderIcon(),

        this.state.showTooltip &&
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.tooltip, this.props.packageName) },
          this.props.msg,
          this.props.children)));




  };return BottomTooltip;}(_react.Component);



BottomTooltip.propTypes = {
  msg: _propTypes2.default.any,
  className: _propTypes2.default.string,
  onToggle: _propTypes2.default.func,
  showOnHover: _propTypes2.default.bool,
  packageName: _propTypes2.default.string,
  children: _propTypes2.default.node,
  warnTooltip: _propTypes2.default.bool,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element]),
  closeOnClickOutside: _propTypes2.default.bool };exports.default =


BottomTooltip;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BottomTooltip/BottomTooltip.js
// module id = 2630
// module chunks = 0